import { Materia, ModuloOrientativo } from "..";

export interface ModuliResponse {
    canActivate: boolean;
    materia : Materia;
    moduli: Array<ModuloOrientativo>;
}